<template>
    
    <div class="dialog-cover">

        <img 
            :src="images.gradient" 
            class="pdl-success-gradient" 
            v-if="isSuccess"
        />

        <div id="puzzle-dialog-container">

            <div class="pdl-success-tip" v-if="isSuccess"> 
                恭喜，拼图成功！
            </div>

            <div class="pdl-success-tip" v-else style="top: 21.5%"> 
                再接再厉 再<span style="font-size: 1.5rem; color: #FFA548">拼</span>佳绩
            </div>

            <div class="puzzle-dialog-info">
                
                <img :src="imgUrl" class="pdi-image" />

                <div class="pdi-detail"> 
                    {{ detail }}
                </div>
            </div>

            <div class="puzzle-dialog-like"> 

                <div class="pdl-like-detail"> 

                    <div class="pdl-like-detail-title"> 祝福香港</div>

                    <div class="pdl-like-detail-info">
                        已获得{{ num }}个祝福
                    </div>
                </div>

                <div class="pdl-like-btn-bg" @click="handleLikeBtnClick"> 
                    <img :src="images.likeBtn" class="pdl-like-btn" />
                </div>

                <img :src="images.like" id="pdl-like-icon-1" style="display: none" />
            </div>

            <img :src="images.medal" class="pdl-medal" v-if="isSuccess" />
            <img :src="images.emoji" class="pdl-emoji" v-if="!isSuccess" />

            <img :src="images.ribbon" class="pdl-ribbon" v-if="isSuccess" />
        </div>

        <div class="puzzle-dialog-btn-group">

            <img 
                :src="images.continueBtn" 
                class="pdbg-btn" 
                id="pdbg-continue" 
                @click="continueToPuzzle"
            />

            <img 
                :src="images.shareBtn" 
                class="pdbg-btn" 
                @click="openShareDialog"
            />
        </div>
    </div>
</template>

<script>

    import { useRouter, useRoute } from 'vue-router';
    import { 
        reactive, 
        toRefs, 
        computed, 
        onMounted
    } from 'vue';

    import likeBg from "@/assets/puzzle/dialog/like-bg.png";
    import likeBtn from "@/assets/puzzle/dialog/like-btn.png";
    import likeIcon from "@/assets/puzzle/dialog/like.png";
    import medalIcon from "@/assets/puzzle/dialog/medal.png";
    import ribbonIcon from "@/assets/puzzle/dialog/ribbon.png";
    import emojiIcon from "@/assets/puzzle/dialog/emoji.png";
    import gradientImage from "@/assets/puzzle/dialog/gradient.png";
    import shareBtn from "@/assets/puzzle/dialog/share-btn.png";
    import continueBtn from "@/assets/puzzle/dialog/continue-btn.png";

    export default {
        name: "PuzzleDialog",
        props: {
            isSuccess: {
                type: Boolean
            },
            addRequest: {
                type: Function
            },
            num: {
                type: Number
            },
            detail: {
                type: String
            },
            openShareDialog: {
                type: Function
            }
        },
        setup(props) {

            const router = useRouter();
            const route = useRoute();

            const state = reactive({
                images: {
                    likeBg,
                    likeBtn,
                    like: likeIcon,
                    medal: medalIcon,
                    ribbon: ribbonIcon,
                    emoji: emojiIcon,
                    gradient: gradientImage,
                    shareBtn,
                    continueBtn
                },
                imageId: null
            });

            onMounted(() => {
                init();
            });
            
            const imgUrl = computed(() => {

                if (!state.imageId) {
                    return "";
                }

                const numId = state.imageId.split("-")[1];

                return `./puzzleimage/${state.imageId}/${numId}.jpg`;
            });

            const init = () => {

                const { id } = route.query;

                state.imageId = id;
            };

            const continueToPuzzle = () => {

                router.replace({
                    name: "Card"
                });
            };

            const handleLikeBtnClick = () => {

                const element = document.querySelector("#pdl-like-icon-1");

                element.style.display = "";

                setTimeout(() => {
                    element.style.display = "none";
                }, 800);

                props.addRequest();
            };

            return {
                ...toRefs(state),
                continueToPuzzle,
                imgUrl,
                handleLikeBtnClick
            };
        }
    };
</script>

<style lang="scss" scoped>

    .pdl-success-gradient {
        position: fixed;
        left: -50%;
        right: 0;
        top: -10%;
        bottom: 0;
        width: 200vw;
        opacity: 0.55;
        animation: rotate360 7s linear 0.2s infinite;
        -webkit-animation: rotate360 7s linear 0.2s infinite;
    }

    @keyframes rotate360 {

        100% {
            transform: rotate(360deg);
            -webkit-transform: rotate(360deg);
        }
    }

    @media screen and (min-height: 800px) {
        
        #puzzle-dialog-container {

            background: linear-gradient(0deg, #FFFFFF, #FFF6E2);
            position: fixed;
            top: 17.5%;
            left: 10%;
            border-radius: 10px;
            height: 57.5%;
            width: 80%;

            .puzzle-dialog-info {
                background-color: #FFEEE7;
                border-radius: 5px;
                position: fixed;
                top: 25.9%;
                left: 15%;
                height: 36%;
                width: 71%;
            }

            .puzzle-dialog-like {
                
                position: fixed;
                top: 62.6%;
                left: 12%;
                width: calc(745px / 2.45);
                height: calc(195px / 2.45);
                background-image: url(../assets/puzzle/dialog/like-bg.png);
                background-position: 50% 50%;
                background-size: auto 100%;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                padding-top: 0.5rem;

                .pdl-like-bg {
                    width: 84%;
                    height: auto;
                }

                .pdl-like-detail {

                    position: relative;
                    left: 25.2%;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    vertical-align: center;

                    .pdl-like-detail-title {
                        color: #FF2359;
                        font-weight: bold;
                        font-family: Source Han Sans CN;
                        font-size: 0.9rem;
                        letter-spacing: 0.05rem;
                        margin-bottom: 0.4rem;
                    }

                    .pdl-like-detail-info {
                        color: #D7915B;
                        font-size: 0.7rem;
                    }
                }

                .pdl-like-btn-bg {
                    background-color: #FFE4CC; 
                    width: 2.3rem; 
                    height: 2.3rem; 
                    border-radius: 50%; 
                    cursor: pointer;
                    position: relative;
                    right: 2%;
                }

                .pdl-like-btn {
                    width: calc(88px / 2.5);
                    height: calc(85px / 2.5);
                    position: relative;
                    left: calc((100% - 88px / 2.5) / 2);
                    top: calc(100% - 85px / 2.5);
                    animation: tada 1s linear infinite;
                    -webkit-animation: tada 1s linear infinite;
                }

                @-webkit-keyframes tada {

                    0% {
                        -webkit-transform: scale(1);
                        transform:scale(1)
                    }
                    
                    10%,
                    20%{
                        -webkit-transform: scale(0.9);
                        transform: scale(0.9)
                    }
                    
                    30%,
                    50%,
                    70%,
                    90%{
                        -webkit-transform: scale(1.1);
                        transform:scale(1.1) 
                    }
                    
                    40%,60%,80%{
                        -webkit-transform: scale(1.1);
                        transform:scale(1.1)
                    }
                    
                    100%{
                        -webkit-transform: scale(1);
                        transform: scale(1)
                    }
                }

                @keyframes bubble_y {

                    0% {
                        position: fixed;
                        right: 4.3rem;
                        bottom: 31.1%;
                        width: 1.5rem;
                    }

                    25% {
                        width: 0.8rem;
                        position: fixed;
                        right: 5.1rem;
                        bottom: 33.1%;
                    }

                    50% {
                        width: 0.6rem;
                        position: fixed;
                        right: 5.3rem;
                        bottom: 35.2%;
                    }

                    100% {
                        width: 0.5rem;
                        position: fixed;
                        right: 5.7rem;
                        bottom: 38.2%;
                        opacity: 0;
                    }
                }

                #pdl-like-icon-1 {
                    width: 0.8rem;
                    position: relative;
                    right: 4.7rem;
                    bottom: 32.1%;
                    animation: bubble_y 0.8s linear 1 forwards;
                }
            }

            .pdl-medal {
                position: fixed;
                top: 15%;
                left: calc((100% - 15%) / 2);
                width: 15%;
            }

            .pdl-ribbon {
                position: fixed;
                width: 19rem;
                left: calc((100% - 19rem) / 2);
                top: 6.6%;
            }

            .pdl-emoji {
                position: fixed;
                width: 8rem;
                top: 13.8%;
                left: 35%;
            }

            .pdl-success-tip {
                position: fixed;
                text-align: center;
                width: 80%;
                top: 22.5%;
                color: #D7915B;
                font-style: italic;
                font-weight: bold;
                font-size: 1.1rem;
                letter-spacing: 0.2rem;
            }

            .pdi-image {
                width: 30%;
                position: fixed;
                top: 28.2%;
                left: calc((100% - 30%) / 2);
                border: 4px solid white;
                border-radius: 16px;
            }

            .pdi-detail {
                color: #9D693A;
                font-size: 13px;
                line-height: 1.3rem;
                letter-spacing: 0.1rem;
                position: fixed;
                top: calc(28.2% + 16%);
                width: 62%;
                left: calc((100% - 62%) / 2);
                text-indent: 26px;
            }
        }

        .puzzle-dialog-btn-group {

            display: flex;
            flex-direction: row;
            align-items: center;
            position: fixed;
            top: calc(17.5% + 57.5% + 2%);
            left: 9%;

            .pdbg-btn {
                width: 43%;
            }

            #pdbg-continue {
                margin-right: 1rem;
            }
        }
    }

    @media screen and (max-height: 800px) {
        
        #puzzle-dialog-container {

            background: linear-gradient(0deg, #FFFFFF, #FFF6E2);
            position: fixed;
            top: 15.5%;
            left: 10%;
            border-radius: 10px;
            height: 63%;
            width: 80%;

            .puzzle-dialog-info {
                background-color: #FFEEE7;
                border-radius: 5px;
                position: fixed;
                top: 25.9%;
                left: 15%;
                height: 40%;
                width: 71%;
            }

            .puzzle-dialog-like {
                
                position: fixed;
                top: 65.6%;
                left: 12%;
                width: calc(745px / 2.7);
                height: calc(195px / 2.7);
                background-image: url(../assets/puzzle/dialog/like-bg.png);
                background-position: 50% 50%;
                background-size: auto 100%;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                padding-top: 0.5rem;

                .pdl-like-bg {
                    width: 84%;
                    height: auto;
                }

                .pdl-like-detail {

                    position: relative;
                    left: 25%;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    vertical-align: center;

                    .pdl-like-detail-title {
                        color: #FF2359;
                        font-weight: bold;
                        font-family: Source Han Sans CN;
                        font-size: 0.9rem;
                        letter-spacing: 0.05rem;
                        margin-bottom: 0.4rem;
                    }

                    .pdl-like-detail-info {
                        color: #D7915B;
                        font-size: 0.7rem;
                    }
                }

                .pdl-like-btn-bg {
                    background-color: #FFE4CC; 
                    width: 2.3rem; 
                    height: 2.3rem; 
                    border-radius: 50%; 
                    cursor: pointer;
                    position: relative;
                    right: 2%;
                }

                .pdl-like-btn {
                    position: relative;
                    left: 6%;
                    top: 18%;
                    width: 2rem;
                    animation: tada 1s linear infinite;
                    -webkit-animation: tada 1s linear infinite;
                }

                @-webkit-keyframes tada {

                    0% {
                        -webkit-transform: scale(1);
                        transform:scale(1)
                    }
                    
                    10%,
                    20%{
                        -webkit-transform: scale(0.9);
                        transform: scale(0.9)
                    }
                    
                    30%,
                    50%,
                    70%,
                    90%{
                        -webkit-transform: scale(1.1);
                        transform:scale(1.1) 
                    }
                    
                    40%,60%,80%{
                        -webkit-transform: scale(1.1);
                        transform:scale(1.1)
                    }
                    
                    100%{
                        -webkit-transform: scale(1);
                        transform: scale(1)
                    }
                }

                @keyframes bubble_y {

                    0% {
                        position: fixed;
                        right: 4.3rem;
                        bottom: 28.1%;
                        width: 1.5rem;
                    }

                    25% {
                        width: 0.8rem;
                        position: fixed;
                        right: 5.1rem;
                        bottom: 32.1%;
                    }

                    50% {
                        width: 0.6rem;
                        position: fixed;
                        right: 5.3rem;
                        bottom: 33.2%;
                    }

                    100% {
                        width: 0.5rem;
                        position: fixed;
                        right: 5.7rem;
                        bottom: 35.2%;
                        opacity: 0;
                    }
                }

                #pdl-like-icon-1 {
                    width: 0.8rem;
                    position: fixed;
                    right: 4.7rem;
                    bottom: 32.1%;
                    animation: bubble_y 0.8s linear 1 forwards;
                }
            }

            .pdl-medal {
                position: fixed;
                top: 12%;
                left: calc((100% - 15%) / 2);
                width: 15%;
            }

            .pdl-ribbon {
                position: fixed;
                width: 16rem;
                left: calc((100% - 16rem) / 2);
                top: 6.6%;
            }

            .pdl-emoji {
                position: fixed;
                width: 8rem;
                top: 10.6%;
                left: 35%;
            }

            .pdl-success-tip {
                position: fixed;
                text-align: center;
                width: 80%;
                top: 22.5%;
                color: #D7915B;
                font-style: italic;
                font-weight: bold;
                font-size: 1.1rem;
                letter-spacing: 0.2rem;
            }

            .pdi-image {
                width: 32%;
                position: relative;
                top: 1rem;
                left: calc((100% - 32%) / 2);
                border: 4px solid white;
                border-radius: 16px;
            }

            .pdi-detail {
                color: #9D693A;
                font-size: 13px;
                line-height: 1.3rem;
                letter-spacing: 0.1rem;
                position: relative;
                width: 88%;
                top: 1rem;
                left: calc((100% - 88%) / 2);
                text-indent: 26px;
                height: calc(40%);
                overflow-y: auto;
                margin-top: 0.5rem;
            }

            .pdi-detail::-webkit-scrollbar {
                width: 3px;
                background-color: transparent;
            }

            .pdi-detail::-webkit-scrollbar-track {
                background-color: transparent;
            }

            .pdi-detail::-webkit-scrollbar-thumb {
                background-color: #fae7dd !important;
            }
        }

        .puzzle-dialog-btn-group {

            display: flex;
            flex-direction: row;
            align-items: center;
            position: fixed;
            top: calc(15.5% + 63% + 5%);
            left: 9%;

            .pdbg-btn {
                width: 43%;
            }

            #pdbg-continue {
                margin-right: 1rem;
            }
        }
    }
</style>